<template>
    <div class="p-role-permission">
    	<div v-if="!($route.name.match(/-chart/) || $route.name.match(/-editor/))" class="row margin-bottom-medium">
    		<div class="col-xs-12">
    			<h1 class="st-headline st-headline--1">{{ title }}</h1>
    		</div>
    	</div>
    	<router-view></router-view>
    </div>
</template>

<script>
// Base
import Vue from 'vue';

// Componenets

// funktion

// helper
import help_rest from '@/helpers/rest';

export default {

	name: 'p-role-permission',

	props: {
		role: {
			type: String,
			default: ''
		}
	},

	data(){
		return {
			permissions: {}
		};
	},


	methods: {
		...help_rest,
		init(){
			restget('/api/v1/roles/' + role, role + '-permission')
			.then(msg => {
				console.log(msg)
			});
		},
	},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/p-role-permission.vue